import React, { useRef, useState, useEffect } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import { getLeadSourcesFromCache } from "../../hooks/useLeadSourceCache";

const LeadSourceDropdown = ({
  onSelect,
  placeholder = "Select Lead Source",
  selectedLeadSourceId = null, // New prop to track selected lead source
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [leadSourceSearch, setLeadSourceSearch] = useState("");
  const [filteredSources, setFilteredSources] = useState([]);
  const [allSources, setAllSources] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState(null);

  const dropdownRef = useRef();
  useOutsideClick(dropdownRef, () => setShowDropdown(false));

  useEffect(() => {
    const sources = getLeadSourcesFromCache();
    setAllSources(sources);
  }, []);

  const handleSelect = (item) => {
    setLeadSourceSearch(item.name);
    onSelect(item);
    setShowDropdown(false);
  };

  useEffect(() => {
    const searchKey = leadSourceSearch.trim().toLowerCase();

    if (!searchKey) {
      // Show all sources when no search term is entered
      setFilteredSources(allSources);
      return;
    }

    const matchedSource = allSources.filter((item) =>
      item.name.toLowerCase().includes(searchKey)
    );

    if (!matchedSource) {
      setFilteredSources([]);
      return;
    }
    let filteredItems = [];

    const matchedItems = matchedSource.map((id) => {
      const docId = id.id;
      const result = allSources.filter((item) => {
        if (item.path.includes(docId)) {
          filteredItems.push(item);
        }
      });
    });

    setFilteredSources(filteredItems);
  }, [leadSourceSearch]);
  return (
    <div ref={dropdownRef} className="w-full relative">
      <div
        className="w-full flex flex-col border border-gray-300 hover:border-customGreen rounded-md px-2"
        onClick={(e) => {
          e.stopPropagation();
          setShowDropdown(true);
        }}
      >
        <div className="relative">
          <input
            value={leadSourceSearch}
            onChange={(e) => setLeadSourceSearch(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            onFocus={() => setShowDropdown(true)}
            className="w-full px-2 py-2 outline-none"
            placeholder={placeholder}
          />
        </div>

        {showDropdown && (
          <div className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-md mt-1 z-10 shadow max-h-60 overflow-y-auto">
            <div className="px-2 mt-3 pb-2">
              {}
              {filteredSources.length > 0 ? (
                filteredSources.map((item) => (
                  <>
                    <div
                      key={item.id}
                      className="p-2 border border-gray-200 hover:border-green-400 rounded-[10px] mb-2 hover:bg-green-100 cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelect(item);
                      }}
                    >
                      <div className="flex flex-col gap-1">
                        <div className="font-medium">{item.name}</div>

                        <div className="text-sm text-gray-400 break-words">
                          Path:{" "}
                          {item.path
                            .map((id) => {
                              const found = allSources.find(
                                (src) => src.id === id
                              );

                              return found ? found.name : id;
                            })
                            .join(" ⇒ ")}
                        </div>
                      </div>
                    </div>
                  </>
                ))
              ) : (
                <div className="p-2 text-sm text-gray-400">
                  No results found
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadSourceDropdown;
